import React from 'react';
import { FormattedMessage } from 'react-intl';

function TableHead(props) {
  return (
    <thead className="thead-light">
      <tr>
        <th></th>
        <th
          className="code"
          data-sort="code"
          scope="col"
          onClick={ () => props.applySort('code') }
        >
          <FormattedMessage id="components.pages.management.manageCampaigns.table.code" />
        </th>
        <th
          className="type"
          data-sort="type"
          scope="col"
          onClick={ () => props.applySort('type') }
        >
          <FormattedMessage id="components.pages.management.manageCampaigns.table.type" />
        </th>
        <th
          className="start_date"
          data-sort="start_date"
          scope="col"
          onClick={ () => props.applySort('start_date') }
        >
          <FormattedMessage id="components.pages.management.manageCampaigns.table.start_date" />
        </th>
        <th
          className="end_date"
          data-sort="end_date"
          scope="col"
          onClick={ () => props.applySort('end_date') }
        >
          <FormattedMessage id="components.pages.management.manageCampaigns.table.end_date" />
        </th>
        <th
          className="created_at"
          data-sort="created_at"
          scope="col"
          onClick={ () => props.applySort('created_at') }
        >
          <FormattedMessage id="components.pages.management.manageCampaigns.table.created_at" />
        </th>
        <th
          className="updated_at"
          data-sort="updated_at"
          scope="col"
          onClick={ () => props.applySort('end_date') }
        >
          <FormattedMessage id="components.pages.management.manageCampaigns.table.updated_at" />
        </th>

        <th
          scope="row"
          className="w-10"
        >
          <FormattedMessage id="components.pages.management.manageOrders.table.actions" />
        </th>
      </tr>
    </thead>
  )
}

export { TableHead };
